// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectComponents_profile-summary__pBjJq {
  display: flex;
}
.SelectComponents_profile-summary__pBjJq .SelectComponents_profile-img__100q- img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.SelectComponents_profile-summary__pBjJq .SelectComponents_profile-info__xOwp3 {
  margin-left: 10px;
  color: #6f6f6f;
}
.SelectComponents_profile-summary__pBjJq .SelectComponents_profile-info__xOwp3 .SelectComponents_profile-name__3Okor {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}

.SelectComponents_management-scope-item__GD\\+-p {
  display: flex;
  background-color: white;
}
.SelectComponents_management-scope-item__GD\\+-p .SelectComponents_management-scope__oOvJq img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.SelectComponents_management-scope-item__GD\\+-p .SelectComponents_management-scope-info__Ebqbk {
  margin-left: 10px;
  color: #6f6f6f;
}
.SelectComponents_management-scope-item__GD\\+-p .SelectComponents_management-scope-info__Ebqbk .SelectComponents_management-scope-name__tToRd {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}

.SelectComponents_select-mapped-profile__rlw5P {
  margin-top: 5px;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_chosen-profile__VghR\\+ {
  background: white;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_chosen-profile__VghR\\+ .SelectComponents_profile__2V6NP {
  display: flex;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_chosen-profile__VghR\\+ .SelectComponents_profile__2V6NP .SelectComponents_profile-img__100q- img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_chosen-profile__VghR\\+ .SelectComponents_profile__2V6NP .SelectComponents_profile-info__xOwp3 {
  margin-left: 10px;
  color: #6f6f6f;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_chosen-profile__VghR\\+ .SelectComponents_profile__2V6NP .SelectComponents_profile-info__xOwp3 .SelectComponents_profile-name__3Okor {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_delete-chosen-profile__LJoRZ {
  cursor: pointer;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_open-detail-profile__wpBPx {
  color: var(--profile-management-color);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.SelectComponents_select-mapped-profile__rlw5P .SelectComponents_open-detail-profile__wpBPx svg {
  margin-left: 5px;
}

.SelectComponents_select-management-scope__iak9J {
  margin-top: 5px;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_chosen-scope__32JMb {
  background: white;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_chosen-scope__32JMb .SelectComponents_management-scope-info__Ebqbk {
  margin-left: 10px;
  color: #6f6f6f;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_chosen-scope__32JMb .SelectComponents_management-scope-info__Ebqbk .SelectComponents_management-scope-name__tToRd {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_chosen-scope__32JMb .SelectComponents_management-scope-chosen__39tHv {
  display: flex;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_chosen-scope__32JMb .SelectComponents_management-scope-chosen__39tHv .SelectComponents_management-scope__oOvJq img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.SelectComponents_select-management-scope__iak9J .SelectComponents_delete-chosen-profile__LJoRZ {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Components/SelectComponents/SelectComponents.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACN;AAEE;EACE,iBAAA;EACA,cAAA;AAAJ;AACI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AACN;;AAGA;EACE,aAAA;EACA,uBAAA;AAAF;AAEI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAAN;AAGE;EACE,iBAAA;EACA,cAAA;AADJ;AAEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAAN;;AAIA;EACE,eAAA;AADF;AAEE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAAJ;AACI;EACE,aAAA;AACN;AACQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACV;AAEM;EACE,iBAAA;EACA,cAAA;AAAR;AACQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AACV;AAIE;EACE,eAAA;AAFJ;AAIE;EACE,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AAGI;EACE,gBAAA;AADN;;AAKA;EACE,eAAA;AAFF;AAGE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AADJ;AAEI;EACE,iBAAA;EACA,cAAA;AAAN;AACM;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AACR;AAEI;EACE,aAAA;AAAN;AAEQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAAV;AAKE;EACE,eAAA;AAHJ","sourcesContent":[".profile-summary {\n  display: flex;\n  .profile-img {\n    img {\n      width: 80px;\n      height: 80px;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n  }\n  .profile-info {\n    margin-left: 10px;\n    color: #6f6f6f;\n    .profile-name {\n      color: black;\n      font-weight: 600;\n      font-size: 16px;\n      margin-bottom: 5px !important;\n    }\n  }\n}\n.management-scope-item {\n  display: flex;\n  background-color: white;\n  .management-scope {\n    img {\n      width: 80px;\n      height: 80px;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n  }\n  .management-scope-info {\n    margin-left: 10px;\n    color: #6f6f6f;\n    .management-scope-name {\n      color: black;\n      font-weight: 600;\n      font-size: 16px;\n      margin-bottom: 5px !important;\n    }\n  }\n}\n.select-mapped-profile {\n  margin-top: 5px;\n  .chosen-profile {\n    background: white;\n    padding: 15px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    .profile {\n      display: flex;\n      .profile-img {\n        img {\n          width: 80px;\n          height: 80px;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n      .profile-info {\n        margin-left: 10px;\n        color: #6f6f6f;\n        .profile-name {\n          color: black;\n          font-weight: 600;\n          font-size: 16px;\n          margin-bottom: 5px !important;\n        }\n      }\n    }\n  }\n  .delete-chosen-profile {\n    cursor: pointer;\n  }\n  .open-detail-profile {\n    color: var(--profile-management-color);\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    svg {\n      margin-left: 5px;\n    }\n  }\n}\n.select-management-scope {\n  margin-top: 5px;\n  .chosen-scope {\n    background: white;\n    padding: 15px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    .management-scope-info {\n      margin-left: 10px;\n      color: #6f6f6f;\n      .management-scope-name {\n        color: black;\n        font-weight: 600;\n        font-size: 16px;\n        margin-bottom: 5px !important;\n      }\n    }\n    .management-scope-chosen {\n      display: flex;\n      .management-scope {\n        img {\n          width: 80px;\n          height: 80px;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n  .delete-chosen-profile {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-summary": `SelectComponents_profile-summary__pBjJq`,
	"profile-img": `SelectComponents_profile-img__100q-`,
	"profile-info": `SelectComponents_profile-info__xOwp3`,
	"profile-name": `SelectComponents_profile-name__3Okor`,
	"management-scope-item": `SelectComponents_management-scope-item__GD+-p`,
	"management-scope": `SelectComponents_management-scope__oOvJq`,
	"management-scope-info": `SelectComponents_management-scope-info__Ebqbk`,
	"management-scope-name": `SelectComponents_management-scope-name__tToRd`,
	"select-mapped-profile": `SelectComponents_select-mapped-profile__rlw5P`,
	"chosen-profile": `SelectComponents_chosen-profile__VghR+`,
	"profile": `SelectComponents_profile__2V6NP`,
	"delete-chosen-profile": `SelectComponents_delete-chosen-profile__LJoRZ`,
	"open-detail-profile": `SelectComponents_open-detail-profile__wpBPx`,
	"select-management-scope": `SelectComponents_select-management-scope__iak9J`,
	"chosen-scope": `SelectComponents_chosen-scope__32JMb`,
	"management-scope-chosen": `SelectComponents_management-scope-chosen__39tHv`
};
export default ___CSS_LOADER_EXPORT___;
